<template>
    <div style="background:grey">
        <el-button type="danger" v-if="ifdatamodify" @dblclick.native="datamodify">合并更改数据
        </el-button>
        <el-input placeholder="如果为空，那么也就默认为所有" v-model="fieldstr">
            <el-button v-bind:style="{ background: fieldsetting ? '#64fa93' : '#F5F7FA' }" slot="prepend"
                @click="fieldset">选择field</el-button>
        </el-input>
        <el-input v-model="modifystr">
        </el-input>


    </div>
</template>
<script>
export default {
    props: ["tableleveldata", "datafromsingleclct"],
    data() {
        return {
            fieldstr: "",
            fieldobj: {},
            fieldsetting: false,
            modifystr: ""
        }
    },
    computed: {
        ifdatamodify() {
            return this.$store.state.roles.includes('superadmin')
        },
    },
    methods: {
        fieldset() {
            if (this.fieldsetting == false) {
                this.fieldstr = ""
                this.fieldobj = {}
                this.fieldsetting = true
            }
            else {
                this.fieldsetting = false
            }

        },


        cilckfromsigleclct(singledata) {
            if (this.fieldsetting == true) {
                this.fieldobj[singledata.field.name] = singledata.field.name
                this.fieldstr = JSON.stringify(this.fieldobj)
            }
            if (this.fieldstr == "") {
                this.modifystr = JSON.stringify(singledata.data)
            }
            else {
                try {
                    let fieldobj = JSON.parse(this.fieldstr)
                    let modifyobj = {}
                    for (let k in fieldobj) {
                        modifyobj[fieldobj[k]] = singledata.data[k]
                    }
                    this.modifystr = JSON.stringify(modifyobj)
                }
                catch (e) {
                    this.$message({ type: "error", message: "格式错误，请检查" })
                }
            }

        },
        datamodify() {
            let modifyobj = JSON.parse(this.modifystr)

            modifyobj._id = this.tableleveldata._id//很重要，因为modify是根据_id查找原值

            delete modifyobj.name

            this.$axios
                .post(url + "modifyfromaggpage", {
                    collection: this.$store.state.clct,
                    data: [modifyobj],
                })
                .then((res) => {
                    this.$message("提交成功success submit");
                });
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/presentation/table/popup_modify.vue